<template>
  <!-- Le contenu reste inchangé -->
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PreferencesSetter',
  components: {},
  props: {},
  data() {
    return {
      eventsIds: [],
      title: '',
      description: '',
      label: '',
      type: '',
      dataToSet: '',
      inputProps: {},
      propertiesDetails: {
        oneWinAccountId: {
          title: this.$t('preferences.xbetAccountId.title'),
          description: `<img src="/images/screenshots/1win-account-id-getting.webp" class="object-cover w-full h-[120px] object-top rounded-2xl" style="filter: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06))" />`,
          label: this.$t('preferences.oneWinAccountId.label'),
          type: 'text',
          inputProps: {
            trim: true,
          },
        },
        xbetAccountId: {
          title: this.$t('preferences.xbetAccountId.title'),
          description: `<img src="/images/screenshots/1xbet-account-id-getting.webp" class="object-cover w-full h-[120px] object-top rounded-2xl" style="filter: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06))" />`,
          label: this.$t('preferences.xbetAccountId.label'),
          type: 'text',
          inputProps: {
            trim: true,
          },
        },
        betwinnerAccountId: {
          title: this.$t('preferences.betwinnerAccountId.title'),
          description: `<img src="/images/screenshots/betwinner-account-id-getting.webp" class="object-cover w-full h-[120px] object-top rounded-2xl" style="filter: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06))" />`,
          label: this.$t('preferences.betwinnerAccountId.label'),
          type: 'text',
          inputProps: {
            trim: true,
          },
        },
        melbetAccountId: {
          title: this.$t('preferences.melbetAccountId.title'),
          description: `<img src="/images/screenshots/melbet-account-id-getting.png" class="object-cover w-full h-[120px] object-top rounded-2xl" style="filter: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06))" />`,
          label: this.$t('preferences.melbetAccountId.label'),
          type: 'text',
          inputProps: {
            trim: true,
          },
        },
        eightStarzAccountId: {
          title: this.$t('preferences.eightStarzAccountId.title'),
          description: `<img src="/images/screenshots/eightStarz-account-id-getting.webp" class="object-cover w-full h-[120px] object-top rounded-2xl" style="filter: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06))" />`,
          label: this.$t('preferences.eightStarzAccountId.label'),
          type: 'text',
          inputProps: {
            trim: true,
          },
        },
      },
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'preference_update_requested',
      this.onPreferenceUpdateRequested,
    )
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    async onPreferenceUpdateRequested(data) {
      if (!data.dataToSet) {
        this.$Events.dispatchEvent('failed_to_init_preferences_setting', data)
        return
      }
      this.dataToSet = data.dataToSet
      this.title = data.title
      this.title ||= (this.propertiesDetails[this.dataToSet] || {}).title || ''
      this.description = data.description
      this.description ||=
        (this.propertiesDetails[this.dataToSet] || {}).description || ''
      this.label = data.label
      this.label ||= (this.propertiesDetails[this.dataToSet] || {}).label || ''
      this.type = data.type
      this.inputProps =
        data.inputProps ||
        (this.propertiesDetails[this.dataToSet] || {}).inputProps ||
        {}
      this.type ||=
        (this.propertiesDetails[this.dataToSet] || {}).type || 'text'

      const currentPreferences = await this.getPreferences()

      let isClient = false
      try {
        if (window) isClient = true
      } catch (error) {
        console.log(error)
      }
      if (!isClient) {
        return this.$Events.dispatchEvent('failed_to_set_preferences', {
          cause: 'not client env',
        })
      }
      const prompt = await window.customPrompt({
        title: this.title,
        subTitle: this.description,
        formFields: [
          {
            type: this.type,
            propertyName: this.dataToSet,
            label: this.label,
            defaultValue: currentPreferences[this.dataToSet] || '',
            required: true,
            inputProps: this.inputProps,
          },
        ],
        successText: this.$t('preferences.save'),
      })
      if (!prompt.accepted) return
      if (
        this.dataToSet == 'betwinnerAccountId' ||
        this.dataToSet == 'melbetAccountId' ||
        this.dataToSet == 'xbetAccountId' ||
        this.dataToSet == 'eightStarzAccountId'
      ) {
        let service
        if (/betwinner/i.test(this.dataToSet)) service = 'betwinner'
        if (/melbet/i.test(this.dataToSet)) service = 'melbet'
        if (/xbet/i.test(this.dataToSet)) service = '1xbet'
        if (/eightStarz/i.test(this.dataToSet)) service = 'eightStarz'
        const accountId =
          prompt.data.xbetAccountId ||
          prompt.data.betwinnerAccountId ||
          prompt.data.melbetAccountId ||
          prompt.data.eightStarzAccountId
        const { canContinue, resetValue } =
          await this.$Events.sendDataRequestResolve(
            'bookmakerAccountDetailsAccepted',
            {
              accountId,
              service,
            },
            9999999999999,
          )
        await new Promise(r => setTimeout(r, 500))
        if (resetValue) return this.onPreferenceUpdateRequested(data)
        if (!canContinue) return
      }
      this.$Events.dispatchEvent('user_preferences_setted', prompt.data)
    },

    unsubscribeToAppInfoResponse() {},

    async getPreferences() {
      const userPreferences = await new Promise(resolve => {
        this.$Events.sendDataRequest('userPreferences', resolve)
      })
      return userPreferences || {}
    },
  },
})
</script>
